import React from 'react';

import homeIcon1 from '../../../assets/images/car-icon.svg';
import homeIcon2 from '../../../assets/images/incentives-icon.svg';
import homeIcon3 from '../../../assets/images/electricians-icon.svg';
import homeIcon4 from '../../../assets/images/home-chargers-icon.svg';
import homeIcon5 from '../../../assets/images/savings-calculator-icon.svg';
import { FormattedMessage } from 'react-intl';

const HomepageCards = () => {
  let cards = [
    {
      id: 'card-1',
      src: homeIcon1,
      label: (
        <FormattedMessage
          id="header.electricVehicles.v2"
          defaultMessage="Explore EVs"
          description="Electric Vehicles Header"
        />
      ),
      link: '/vehicles',
      extraClass: 'ev-vehicles',
    },
    {
      id: 'card-2',
      src: homeIcon2,
      label: (
        <FormattedMessage
          id="header.cards.incentives"
          defaultMessage="Search Incentives"
          description="Search Incentives"
        />
      ),
      link: '/incentives',
      extraClass: 'first',
    },
    {
      id: 'card-3',
      src: homeIcon3,
      label: (
        <FormattedMessage
          id="header.cards.electricians"
          defaultMessage="Find Certified Electricians"
          description="Find Certified Electricians"
        />
      ),
      link: '/electricians',
      extraClass: '',
    },
    {
      id: 'card-4',
      src: homeIcon4,
      label: (
        <FormattedMessage
          id="header.cards.home-chargers"
          defaultMessage="Shop Home Chargers"
          description="Shop Home Chargers"
        />
      ),
      link: '/home-chargers',
      extraClass: 'fourth',
    },
    {
      id: 'card-5',
      src: homeIcon5,
      label: (
        <FormattedMessage
          id="header.cards.rates"
          defaultMessage="View Savings Calculator"
          description="View Savings Calculator"
        />
      ),
      link: '/savingscalculator',
      extraClass: 'last',
    },
  ];

  return (
    <section id="HomepageCards">
      <div className="container">
        {cards.map((card) => {
          return (
            <a
              key={card.id}
              href={card.link}
              className={`card-link ${card.extraClass}`}
            >
              <img alt={`Homepage card icon ${card.link}`} src={card.src} />
              <p>{card.label}</p>
            </a>
          );
        })}
      </div>
    </section>
  );
};

export default HomepageCards;
